import { ListingProps } from '@/types/listing';
import { Leaves } from '@/types/nestedObject';

export type Property = ListingProps['listing']['properties'][number];

export interface DataItemBase {
  description?: (p: Property) => string | null | undefined;
  label?: string;
  // eslint-disable-next-line no-use-before-define
  items?: DataItem[];
}

/** Specify a value getter, the name can be any string */
interface DataItemWithValue extends DataItemBase {
  name: string;
  value: (p: Property) => string | number | null | undefined;
}

/** Specify the name, which needs to be a leaf
 * property of Property, no value getter can exist */
interface DataItemWithName extends DataItemBase {
  name: Leaves<Property>;
}

export type DataItem = DataItemWithName | DataItemWithValue;

export interface DataSection {
  title?: string;
  items: DataItem[];
}

export interface ComputedDataItem {
  label?: string;
  name: string;
  value: string | number | null | undefined;
  description?: string | null | undefined;
  items?: ComputedDataItem[];
}

export interface ComputedDataSection {
  title?: string | undefined;
  items: ComputedDataItem[];
  hasValues: boolean;
}

export function isDataItemWithValue(
  item: DataItemBase | DataItemWithValue,
): item is DataItemWithValue {
  return 'value' in item && typeof item.value === 'function';
}

export type UsePropertyInfoProcessorProps = {
  sections: Record<string, DataSection>;
  getComputedSection: (
    data: DataSection,
    property: Property,
  ) => ComputedDataSection;
  getComputedItem: (data: DataItem, property: Property) => ComputedDataItem;
  isNonEmptyValue: (value: string | number | null | undefined) => boolean;
};

export interface UsePropertyInfoProps<T> {
  processor: (props: UsePropertyInfoProcessorProps) => T;
}
